import { IGameState } from '../../Game/IGameState';
import UIStateHelper from '../../UI/UIStateHelper';
import { PopupID } from '../../UI/PopupID';

export function agreeWithTerms(state: IGameState): IGameState {
    return {
        ...state,
        playerState: {
            ...state.playerState,
            gdprCompliance: true,
        },
        UIState: UIStateHelper.hidePopup(state.UIState, PopupID.GDPR_POPUP),
    };
}
